import Component from './component';
import Connector from './connector';

const DashboardCardEntityTransactionsTradingPairs = () => <Connector component={Component} />;

export default DashboardCardEntityTransactionsTradingPairs;
